import styled from 'styled-components'
import { Button as BootstrapButton } from 'react-bootstrap'

export interface ButtonProps {
  $variant?: 'primary' | 'secondary' | 'success' | 'warning' | 'info' | 'outline'
  $size?: 'sm' | 'md' | 'lg'
  $fullWidth?: boolean
}

export const BaseButton = styled(BootstrapButton)<ButtonProps>`
  border-radius: ${({ theme }) => theme.borderRadius.md};
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  font-weight: 600;
  width: ${({ $fullWidth }) => ($fullWidth ? '100%' : 'auto')};
  position: relative;
  overflow: hidden;
  backdrop-filter: blur(10px);

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
    transition: left 0.5s ease;
  }

  &:hover::before {
    left: 100%;
  }

  ${({ $size, theme }) => {
    switch ($size) {
      case 'sm':
        return `
          padding: ${theme.spacing.xs} ${theme.spacing.sm};
          font-size: 0.875rem;
        `
      case 'lg':
        return `
          padding: ${theme.spacing.md} ${theme.spacing.lg};
          font-size: 1.125rem;
        `
      default:
        return `
          padding: ${theme.spacing.sm} ${theme.spacing.md};
          font-size: 1rem;
        `
    }
  }}

  ${({ $variant, theme }) => {
    switch ($variant) {
      case 'outline':
        return `
          background: transparent;
          border: 2px solid ${theme.colors.primary};
          color: ${theme.colors.primary};
          box-shadow: 0 4px 15px rgba(102, 126, 234, 0.2);
          
          &:hover {
            background: ${theme.colors.primary};
            color: ${theme.colors.text.light};
            transform: translateY(-2px);
            box-shadow: 0 8px 25px rgba(102, 126, 234, 0.4);
          }
        `
      case 'secondary':
        return `
          background: linear-gradient(135deg, ${theme.colors.secondary} 0%, #5a67d8 100%);
          border: none;
          color: ${theme.colors.text.light};
          box-shadow: 0 4px 15px rgba(32, 66, 186, 0.3);
          
          &:hover {
            background: linear-gradient(135deg, #5a67d8 0%, #4c51bf 100%);
            transform: translateY(-2px);
            box-shadow: 0 8px 25px rgba(32, 66, 186, 0.5);
          }
        `
      default:
        return `
          background: linear-gradient(135deg, ${theme.colors.primary} 0%, #6b46c1 100%);
          border: none;
          color: ${theme.colors.text.light};
          box-shadow: 0 4px 15px rgba(64, 37, 99, 0.3);
          
          &:hover {
            background: linear-gradient(135deg, #6b46c1 0%, #553c9a 100%);
            transform: translateY(-2px);
            box-shadow: 0 8px 25px rgba(64, 37, 99, 0.5);
          }
        `
    }
  }}
`
